import React, { useMemo } from 'react';
import { MarketOption as MarketOptionComponent } from './MarketOption';
import { MarketOption } from '../../types/market';

interface OptionSectionProps {
  options: MarketOption[];
  selectedOption: string | null;
  onOptionSelect: (optionId: string) => void;
  disabled?: boolean;
}

export const OptionSection: React.FC<OptionSectionProps> = ({ 
  options, 
  selectedOption, 
  onOptionSelect,
  disabled = false
}) => {
  // Calculate total votes and percentages
  const totalVotes = useMemo(() => {
    return options.reduce((sum, option) => sum + option.votes, 0);
  }, [options]);

  const optionsWithData = useMemo(() => {
    const withPercentage = options.map(option => ({
      ...option,
      percentage: totalVotes > 0 ? (option.votes / totalVotes) * 100 : 0
    }));
    
    // Find leading option (highest percentage)
    const maxPercentage = Math.max(...withPercentage.map(o => o.percentage));
    
    return withPercentage.map(option => ({
      ...option,
      isLeading: option.percentage === maxPercentage && option.percentage > 0
    }));
  }, [options, totalVotes]);

  return (
    <div className="consensus-section">
      <div className="consensus-options">
        {optionsWithData.map((option) => (
          <MarketOptionComponent
            key={option.id}
            option={option}
            isSelected={selectedOption === option.id}
            hasSelection={selectedOption !== null}
            onSelect={onOptionSelect}
            disabled={disabled}
          />
        ))}
      </div>
    </div>
  );
};
